var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-group-mode-tabs" },
    _vm._l(_vm.itens, function(item) {
      return _c(
        "v-tooltip",
        {
          key: item.id,
          attrs: { right: "", disabled: item.semMotivo },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  var attrs = ref.attrs
                  return [
                    _c(
                      "span",
                      _vm._g(
                        _vm._b(
                          { staticClass: "chat-group-mode-tabs__slot" },
                          "span",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "chat-group-mode-tabs__botao ia-sidebar-row ia-sidebar-row--compacto",
                            class: { "ia-sidebar-row--ativo": item.ativo },
                            attrs: {
                              type: "button",
                              disabled: item.bloqueado,
                              "aria-pressed": item.ariaPressed
                            },
                            on: {
                              click: function($event) {
                                return _vm.selecionar(item)
                              }
                            }
                          },
                          [
                            _c("icon-svg", {
                              staticClass: "flex-shrink-0",
                              attrs: {
                                name: item.iconName,
                                size: _vm.tamanhoIcone,
                                color: item.corIcone
                              }
                            }),
                            _c("span", { staticClass: "text-truncate" }, [
                              _vm._v(_vm._s(item.label))
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  ]
                }
              }
            ],
            null,
            true
          )
        },
        [_c("span", [_vm._v(_vm._s(item.motivo))])]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }